import {
   Component,
   OnInit,
   ViewEncapsulation,
   HostListener,
   ChangeDetectorRef,
} from '@angular/core';
import { StockOverviewDataService } from '../stock-screener/services/stock-overview-data-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StockFilterService } from '../stock-screener/services/stock-filter.service';
import { FilterService } from 'src/app/shared/services/filter.service';
import { CountryService } from 'src/app/shared/services/country.service';
import { takeUntil } from 'rxjs';
import { Subject } from 'rxjs';
import { DateAdapter } from '@angular/material/core';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { SubscriptionInfoModel } from 'src/app/models/subscription-info.model';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
    selector: 'app-ipo-component',
    templateUrl: './ipo-component.component.html',
    styleUrls: ['./ipo-component.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class IpoComponentComponent implements OnInit {
   private destroy$ = new Subject<void>();
   page: number = 1;
   totalStocksCount: number = 0;
   trueValue: boolean = true;
   usdMarketCap: string = 'numberOfShares';
   desc: string = 'desc';
   dataType: string = 'ipo';
   activeFiltersCount: number = 0;
   isIpo: boolean = true;
   dataCount: number = 0;
   selectedCountry: string = 'US';
   showDropdown = false;
   tableColumns: any = [];
   disclaimer: string =
      'The Shariah compliance report for pre-IPO companies is based exclusively on the financial statements submitted for the IPO. Any amendments or changes to these financial statements after going public may affect the compliance opinion provided';
   months: { year: number; name: string }[] = [];
   dropdownOpen = false;
   isMonthYearDropdownOpen = false;
   selectedMonth: string = '';
   selectedYear: number | null = null;
   allMonths: string[] = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
   ];
   isTouched = false;
   isValid = false;
   isLoggedIn: boolean = false;
   markTouched() {
      this.isTouched = true;
      this.isValid = this.selectedMonth !== null && this.selectedYear !== null;
   }

   getYearRange(): number[] {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 10 }, (_, i) => currentYear - i);
   }

   // Add this to force update the dropdown view
   reloadDropdowns() {
      // Temporary variables to hold values
      const tempMonth = this.selectedMonth;
      const tempYear = this.selectedYear;

      // Reset and reassign to trigger change detection
      this.selectedMonth = '';
      this.selectedYear = null;
      setTimeout(() => {
         this.selectedMonth = tempMonth;
         this.selectedYear = tempYear;
      });
   }

   // Call this when opening dropdown
   toggleMonthYearDropdown(event: MouseEvent): void {
      event.stopPropagation();
      this.isMonthYearDropdownOpen = !this.isMonthYearDropdownOpen;
      if (this.isMonthYearDropdownOpen) {
         this.generateMonths(); // Generate months only when dropdown is opened
         this.reloadDropdowns();
      }
   }

   navigateToPricing() {
      this.router.navigate(['/pricing']);
   }
   onSelectOption(selectedValues: any[], label: string): void {
      // Check if unlock option is selected
      if (Array.isArray(selectedValues)) {
         const unlockSelected = selectedValues.some((val) => val === 'UNLOCK');
         if (unlockSelected) {
            // Remove 'UNLOCK' to prevent it from staying selected
            this.ngModelBindings[label] = selectedValues.filter(
               (val) => val !== 'UNLOCK'
            );
            this.navigateToPricing();
         }
      }
   }
   onUnlockClick(event: MouseEvent): void {
      // console.log("Unlock")
      event.stopPropagation(); // Prevent selection in ng-select
      this.navigateToPricing(); // Navigate
   }

   onMonthYearChange(): void {
      if (this.selectedMonth && this.selectedYear) {
         this.isMonthYearDropdownOpen = false;

         // Trigger data fetch when both are selected
         const queryParams = {
            page: 1,
         };

         this.router.navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge',
            replaceUrl: true,
         });
         this.getAllIpo();
      }
   }

   clearSelection(type: 'month' | 'year', event: MouseEvent): void {
      event.stopPropagation();
      if (type === 'month') {
         this.selectedMonth = '';
      } else if (type === 'year') {
         this.selectedYear = null;
      }

      // Clear data when selection is cleared
      if (this.selectedTab === 'Priced') {
         this.data = [];
         this.totalStocksCount = 0;
      }
   }

   data: any = [];

   tableColumns1 = [
      {
         header: 'Compliance',
         key: 'sharia_compliance',
         type: undefined,
         sortable: false,
      },
      {
         header: 'Halal Rating',
         key: 'ranking_v2',
         sortable: false,
         type: undefined,
      },
      {
         header: 'Price Range',
         key: 'ipo_price',
         type: 'price-range',
         sortable: false,
      },
      {
         header: 'Shares Offered',
         key: 'ipo_numberOfShares',
         type: 'number_shared',
         sortable: true,
      },
      {
         header: 'Offer Amount',
         key: 'ipo_totalSharesValue',
         type: 'million_offer',
         sortable: true,
      },
      {
         header: 'Expected IPO Date',
         key: 'ipo_date',
         type: 'date',
         sortable: false,
      },
   ];
   tableColumns1IN = [
      {
         header: 'Compliance',
         key: 'sharia_compliance',
         type: undefined,
         sortable: false,
      },
      {
         header: 'Halal Rating',
         key: 'ranking_v2',
         sortable: false,
         type: undefined,
      },

      {
         header: 'Price Range',
         key: 'ipo_price',
         type: 'price-range',
         sortable: false,
      },
      {
         header: 'Shares Offered',
         key: 'ipo_numberOfShares',
         type: 'number_shared',
         sortable: true,
      },
      {
         header: 'Offer Amount',
         key: 'ipo_totalSharesValue',
         type: 'million_offer',
         sortable: true,
      },
      {
         header: 'Issue Opening Date',
         key: 'ipo_open_date',
         type: 'date',
      },
      {
         header: 'Issue Closing Date',
         key: 'ipo_close_date',
         type: 'date',
      },
   ];

   tableColumns2 = [
      {
         header: 'Compliance',
         key: 'sharia_compliance',
         type: undefined,
         sortable: false,
      },
      {
         header: 'Halal Rating',
         key: 'ranking_v2',
         type: undefined,
         sortable: false,
      },

      {
         header: 'IPO Price',
         key: 'ipo_priced_price',
         type: 'amount',
         sortable: false,
      },
      {
         header: 'IPO Date',
         key: 'ipo_priced_date',
         type: 'date',
      },
      {
         header: 'Shares Offered',
         key: 'ipo_numberOfShares',
         type: 'number_shared',
         sortable: true,
      },
      {
         header: 'Offer Amount',
         key: 'ipo_totalSharesValue',
         type: 'million_offer',
         sortable: true,
      },
   ];

   tableColumns2IN = [
      {
         header: 'Compliance',
         key: 'sharia_compliance',
         type: undefined,
         sortable: false,
      },
      {
         header: 'Halal Rating',
         key: 'ranking_v2',
         type: undefined,
         sortable: false,
      },

      {
         header: 'IPO Price',
         key: 'ipo_priced_price',
         type: 'amount',
         sortable: false,
      },
      {
         header: 'Listing Date',
         key: 'ipo_priced_date',
         type: 'date',
      },
      {
         header: 'Shares Offered',
         key: 'ipo_numberOfShares',
         type: 'number_shared',
         sortable: true,
      },
      {
         header: 'Offer Amount',
         key: 'ipo_totalSharesValue',
         type: 'million_offer',
         sortable: true,
      },
      {
         header: 'Issue Opening Date',
         key: 'ipo_open_date',
         type: 'date',
      },
      {
         header: 'Issue Closing Date',
         key: 'ipo_close_date',
         type: 'date',
      },
   ];

   tableColumns3 = [
      {
         header: 'Compliance',
         key: 'sharia_compliance',
         type: undefined,
         sortable: false,
      },
      {
         header: 'Halal Rating',
         key: 'ranking_v2',
         type: undefined,
         sortable: false,
      },

      {
         header: 'Price Range',
         key: 'ipo_price',
         type: 'price-range',
         sortable: false,
      },
      {
         header: 'Withdrawn Date',
         key: 'ipo_withdrwa_date',
         type: 'date',
      },
      {
         header: 'Shares Offered',
         key: 'ipo_numberOfShares',
         type: 'number_shared',
         sortable: true,
      },
      {
         header: 'Offer Amount',
         key: 'ipo_totalSharesValue',
         type: 'million_offer',
         sortable: true,
      },
   ];
   tableColumns3IN = [
      {
         header: 'Compliance',
         key: 'sharia_compliance',
         type: undefined,
         sortable: false,
      },
      {
         header: 'Halal Rating',
         key: 'ranking_v2',
         type: undefined,
         sortable: false,
      },

      {
         header: 'Price Range',
         key: 'ipo_price',
         type: 'price-range',
         sortable: false,
      },
      {
         header: 'Shares Offered',
         key: 'ipo_numberOfShares',
         type: 'number_shared',
         sortable: true,
      },
      {
         header: 'Offer Amount',
         key: 'ipo_totalSharesValue',
         type: 'million_offer',
         sortable: true,
      },
      {
         header: 'Issue Opening Date',
         key: 'ipo_open_date',
         type: 'date',
      },
      {
         header: 'Issue Closing Date',
         key: 'ipo_close_date',
         type: 'date',
      },
   ];

   selectedTab = 'Upcoming';
   selectTab(tab: string) {
      this.selectedTab = tab;

      // Clear month/year selections when switching to Priced tab
      if (tab === 'Priced') {
         this.selectedMonth = '';
         this.selectedYear = null;
      }

      const queryParams = {
         page: 1,
      };

      this.router.navigate([], {
         relativeTo: this.route,
         queryParams,
         queryParamsHandling: 'merge', // Preserve other query params
         replaceUrl: true,
      });
      this.updateTableColumns();
      this.getAllIpo();
   }
   // selectTab(tab: string) {
   //   this.selectedTab = tab;

   //   // Reset to page 1 when changing tabs

   //   // No need to call getAllIpo() directly as it will be triggered by the route change
   // }
   updateTableColumns() {
      switch (this.selectedTab) {
         case 'Upcoming':
            this.tableColumns =
               this.selectedCountry === 'IN'
                  ? this.tableColumns1IN
                  : this.tableColumns1;
            break;
         case 'Priced':
            this.tableColumns =
               this.selectedCountry === 'IN'
                  ? this.tableColumns2IN
                  : this.tableColumns2;
            break;
         case 'Withdrawn':
            this.tableColumns =
               this.selectedCountry === 'IN'
                  ? this.tableColumns3IN
                  : this.tableColumns3;
            break;
         default:
            this.tableColumns = this.tableColumns1; // Default to US upcoming
      }
   }

   setTableColumns() {
      if (this.selectedTab === 'Upcoming') {
         this.tableColumns =
            this.selectedCountry === 'IN'
               ? this.tableColumns1IN
               : this.tableColumns1;
      } else if (this.selectedTab === 'Priced') {
         this.tableColumns =
            this.selectedCountry === 'IN'
               ? this.tableColumns2IN
               : this.tableColumns2;
      } else if (this.selectedTab === 'Withdrawn') {
         this.tableColumns =
            this.selectedCountry === 'IN'
               ? this.tableColumns3IN
               : this.tableColumns3;
      }
   }

   private baseDropdownConfigs = [
      {
         placeholder: '-Select-',
         label: 'Shariah Compliance',
         id: 'shariahCompliance',
         options: [
            { label: 'Halal', value: 'COMPLIANT', disabled: false },
            { label: 'Doubtful', value: 'QUESTIONABLE', disabled: false },
            { label: 'Not halal', value: 'NON_COMPLIANT', disabled: false },
         ],
      },
      {
         placeholder: '-Select-',

         label: 'Musaffa Halal Rating',
         id: 'musaffaHalalRating',
         options: [
            { label: 'A+', value: '9', disabled: false },
            { label: 'A', value: '8', disabled: false },
            { label: 'A-', value: '7', disabled: false },
            { label: 'B+', value: '6', disabled: false },
            { label: 'B', value: '5', disabled: false },
            { label: 'B-', value: '4', disabled: false },
            { label: 'C+', value: '3', disabled: false },
            { label: 'C', value: '2', disabled: false },
            { label: 'C-', value: '1', disabled: false },
         ],
      },
   ];

   // Public property that components will use
   dropdownConfigs = [...this.baseDropdownConfigs];

   updateDropdownOptions() {
      this.dropdownConfigs = this.baseDropdownConfigs.map((config) => {
         // Clone the config to avoid mutation
         const newConfig = { ...config, options: [...config.options] };

         // Add 'unlock' option and disable others if not logged in
         if (!this.isLoggedIn) {
            newConfig.options = newConfig.options.map((option) => ({
               ...option,
               disabled: true, // Disable all original options
            }));
            newConfig.options.unshift({
               label: 'Unlock',
               value: 'unlock',
               disabled: false,
            }); // Add 'Unlock' as enabled
         }

         return newConfig;
      });
   }

   //Calendar implementation
   // selectedYear: number = new Date().getFullYear();
   // selectedMonth: string = '';
   showYearPicker = false;
   // allMonths = [
   //    'JAN',
   //    'FEB',
   //    'MAR',
   //    'APR',
   //    'MAY',
   //    'JUN',
   //    'JUL',
   //    'AUG',
   //    'SEP',
   //    'OCT',
   //    'NOV',
   //    'DEC',
   // ];

   selectMonth(month: string): void {
      this.selectedMonth = month;
      this.showYearPicker = false;

      const queryParams = {
         page: 1,
      };

      this.router.navigate([], {
         relativeTo: this.route,
         queryParams,
         queryParamsHandling: 'merge',
         replaceUrl: true,
      });
      this.getAllIpo();
   }
   generateMonths() {
      // Only generate if not already generated
      if (this.months.length === 0) {
         const start = new Date(2024, 10); // November 2024
         const now = new Date();
         const monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
         ];

         const monthsArray = [];
         let current = new Date(start);

         while (current <= now) {
            monthsArray.push({
               year: current.getFullYear(),
               name: monthNames[current.getMonth()],
            });
            current.setMonth(current.getMonth() + 1);
         }

         this.months = monthsArray;
      }
   }

   // Add this helper method
   getMonthTimestamps(
      monthIndex: number,
      year: number
   ): { start: number; end: number } {
      const startDate = new Date(year, monthIndex, 1);
      const endDate = new Date(year, monthIndex + 1, 0, 23, 59, 59);

      return {
         start: Math.floor(startDate.getTime() / 1000),
         end: Math.floor(endDate.getTime() / 1000),
      };
   }

   onYearSelected(): void {
      this.showYearPicker = false;
      // Optionally reset selectedMonth or trigger API
   }

   // getYearRange(): number[] {
   //    const currentYear = new Date().getFullYear();
   //    const startYear = 2010; // You can choose a different starting point
   //    const years = [];
   //    for (let y = currentYear; y >= startYear; y--) {
   //       years.push(y);
   //    }
   //    return years;
   // }

   filters: {
      shariaCompliance?: string[];
      ranking_v2?: string[];
   } = {};
   ngModelBindings: { [key: string]: any[] } = {
      'Shariah Compliance': [],
      'Musaffa Halal Rating': [],
   };
   isAllComplianceAccessible: boolean = false;
   freeStocks: string[] = [];
   loading: boolean = true;

   constructor(
      private stockService: StockOverviewDataService,
      private route: ActivatedRoute,
      private stockFilterService: StockFilterService,
      private filterService: FilterService,
      private countryService: CountryService,
      private router: Router,
      private authService: AuthService,
      private cdr: ChangeDetectorRef
   ) {}

   ngOnInit(): void {
      this.isLoggedIn = !!this.authService.getUserId();
      this.updateDropdownOptions();
      SubscriptionService.subscriptionData.subscribe(
         async (data: SubscriptionInfoModel) => {
            if (data.isDataFetched) {
               if (data.isSubscribed) {
                  this.isAllComplianceAccessible = true;
               } else {
                  this.freeStocks = await this.stockService.getFreeIpoTickers();
               }
               this.getAllIpo();
            }
         }
      );
      const obs1$ = this.countryService.selectedCountry$.pipe(
         takeUntil(this.destroy$)
      );

      // Initialize with proper columns
      this.updateTableColumns();
      this.getIPODisclaimer();

      this.route.queryParams.subscribe((params: any) => {
         if (params.country) {
            this.selectedCountry = params.country;
            this.updateTableColumns(); // Update when country changes via URL
         } else {
            // Set default to US if no country in URL
            this.selectedCountry = 'US';
            this.updateTableColumns();

            // Optionally update the URL to reflect the default
            const queryParams = {
               country: 'US',
               page: params['page'] ?? 1,
            };
            this.router.navigate([], {
               relativeTo: this.route,
               queryParams,
               queryParamsHandling: 'merge',
               replaceUrl: true,
            });
         }
      });
   }

   openCountriesPopup() {
      // Choose one implementation - either countryService or stockFilterService
      this.countryService.openFilterByCountriesPopup();
      // OR
      // this.stockFilterService.openCountriesPopup();
   }

   checkCountryAndFilterData(params: any) {
      const filterParams = this.filterService.getFilterParams(params);
      if (params['country']) {
         this.selectedCountry = params['country'];
      } else {
         this.selectedCountry = 'US'; // Set default
         const queryParams = {
            country: 'US',
            page: params['page'] ?? 1,
         };
         this.router.navigate([], {
            relativeTo: this.route,
            queryParams,
            queryParamsHandling: 'merge',
            replaceUrl: true,
         });
      }
   }

   onFilterChange(filterType: string, selectedValues: any[]): void {
      // Check if 'unlock' was selected
      if (selectedValues?.includes('unlock')) {
         this.router.navigate(['/pricing']);

         // Reset the selection
         this.ngModelBindings[filterType] =
            this.ngModelBindings[filterType]?.filter((v) => v !== 'unlock') ||
            [];
         return;
      }

      // Normal filter handling (only if logged in, since other options are disabled when not logged in)
      if (this.isLoggedIn) {
         if (filterType === 'Shariah Compliance') {
            this.filters.shariaCompliance = selectedValues;
         } else if (filterType === 'Musaffa Halal Rating') {
            this.filters.ranking_v2 = selectedValues;
         }

         this.updateActiveFiltersCount();
         this.getAllIpo();
      }
   }

   updateActiveFiltersCount(): void {
      this.activeFiltersCount = Object.values(this.filters)
         .filter((value) => value !== undefined && value.length > 0)
         .reduce((sum, current) => sum + current.length, 0);
   }

   handleResetAll() {
      this.filters = {
         shariaCompliance: [],
         ranking_v2: [],
      };

      // Create a new object to trigger change detection
  this.ngModelBindings = {
    'Shariah Compliance': [],
    'Musaffa Halal Rating': [],
  };

  this.cdr.detectChanges(); // Force change detection

  this.updateActiveFiltersCount();
  this.getAllIpo();
   }

   // Optional: Add a method to clear all filters
   clearAllFilters(): void {
      this.filters = {};
      this.activeFiltersCount = 0;
      this.getAllIpo();
   }

   onCountryChange() {
      // Update the query params when country changes
      const queryParams = {
         country: this.selectedCountry,
         page: 1, // Reset to first page when changing country
      };

      this.router.navigate([], {
         relativeTo: this.route,
         queryParams,
         queryParamsHandling: 'merge',
         replaceUrl: true,
      });

      // Reload the data
      this.getAllIpo();
   }

   toggleDropdown() {
      this.showDropdown = !this.showDropdown;
   }
   toggleDropdown1() {
      this.dropdownOpen = !this.dropdownOpen;
   }

   selectCountry(country: string) {
      this.selectedCountry = country;
      this.showDropdown = false;
      this.updateTableColumns();

      // Update the URL with the new country and reset to page 1
      const queryParams = {
         country: this.selectedCountry,
         page: 1, // Reset to first page when changing country
      };

      this.router.navigate([], {
         relativeTo: this.route,
         queryParams,
         queryParamsHandling: 'merge', // Preserve other query params
         replaceUrl: true,
      });

      // This will trigger getAllIpo() through the route subscription
   }

   getCountryName(code: string): string {
      return code === 'US' ? 'USA' : 'India';
   }

   async getAllIpo(): Promise<void> {
      this.route.queryParams.subscribe(async (params: any) => {
         const sortBy = params['sortBy'];
         const sortOrder = params['sortOrder'];
         const page = Number(params['page']) || 1;
         const perPage = 15;
         const country = params['country'] || this.selectedCountry || 'US';

         // Determine status based on selected tab
         let status = '';
         if (this.selectedTab === 'Upcoming') {
            status = 'Upcoming';
         } else if (this.selectedTab === 'Priced') {
            status = 'Priced';
         } else if (this.selectedTab === 'Withdrawn') {
            status = 'Withdrawn';
         }

         let timestampFilter = '';
         if (
            this.selectedTab === 'Priced' &&
            this.selectedMonth &&
            this.selectedYear
         ) {
            const monthIndex = this.allMonths.findIndex(
               (m) => m.toLowerCase() === this.selectedMonth.toLowerCase()
            );

            if (monthIndex >= 0) {
               const { start, end } = this.getMonthTimestamps(
                  monthIndex,
                  this.selectedYear
               );

               let dateField = '';
               if (this.selectedCountry === 'IN') {
                  dateField = 'ipo_priced_date_unix';
               } else if (this.selectedCountry === 'US') {
                  dateField = 'ipo_date_unix';
               }

               if (dateField) {
                  timestampFilter = `${dateField}:>=${start} && ${dateField}:<=${end}`;
               }
            }
         }

         try {
            const response = await this.stockService.getIpoData(
               sortBy,
               sortOrder,
               this.filters.shariaCompliance, // Pass the array directly
               this.filters.ranking_v2, // Pass the array directly
               perPage,
               page,
               status,
               country,
               timestampFilter
            );
            if (this.isAllComplianceAccessible)
               this.data = response.hits.map((hit: any) => hit.document);
            else
               this.data = response.hits.map((hit: any) => {
                  return {
                     ...hit.document,
                     sharia_compliance: this.freeStocks.includes(
                        hit.document.ticker
                     )
                        ? hit.document.sharia_compliance
                        : 'LOCKED',
                     ranking_v2: this.freeStocks.includes(hit.document.ticker)
                        ? hit.document.ranking_v2
                        : 'LOCKED',
                  };
               });
            this.totalStocksCount = this.data.length;
            this.dataCount = response.found;
            this.loading = false;
            //console.log("Data Count:", this.dataCount);
            //console.log('IPO Data:', this.data);
         } catch (error) {
            this.loading = false;
            //console.error('Failed to fetch stock data:', error);
         }
      });
   }

   async getIPODisclaimer() {
      try {
         const response = await this.stockService.getIpoDisclaimer();
         this.disclaimer = response;
         //console.log("respons ishdihsfijwohsifujdsjcnsikujhdfciuhnse", response)
      } catch (e) {
         //console.error("Error is ", e)
      }
   }

   @HostListener('document:click', ['$event'])
   onDocumentClick(event: MouseEvent) {
      const target = event.target as HTMLElement;
      if (!target.closest('.country-selector')) {
         this.showDropdown = false;
      }
   }
}
